/**
 * Single source of truth for chatbot_log status presentation.
 * Shared between BotMessagesTab (chat panel) and the redesigned settings page.
 */
import {
  Clock,
  Calendar,
  Loader2,
  Send,
  CheckCheck,
  Eye,
  AlertTriangle,
  Skull,
  Inbox,
} from "lucide-react";

export const STATUS_LABELS = {
  pending: {
    label: "Chờ gửi",
    color: "text-amber-700",
    bg: "bg-amber-100",
    ring: "ring-amber-200",
    dot: "bg-amber-500",
    icon: Clock,
  },
  scheduled: {
    label: "Đã lên lịch",
    color: "text-blue-700",
    bg: "bg-blue-100",
    ring: "ring-blue-200",
    dot: "bg-blue-500",
    icon: Calendar,
  },
  sending: {
    label: "Đang gửi",
    color: "text-indigo-700",
    bg: "bg-indigo-100",
    ring: "ring-indigo-200",
    dot: "bg-indigo-500 animate-pulse",
    icon: Loader2,
  },
  sent: {
    label: "Đã gửi",
    color: "text-emerald-700",
    bg: "bg-emerald-100",
    ring: "ring-emerald-200",
    dot: "bg-emerald-500",
    icon: Send,
  },
  success: {
    label: "Thành công",
    color: "text-emerald-700",
    bg: "bg-emerald-100",
    ring: "ring-emerald-200",
    dot: "bg-emerald-500",
    icon: CheckCheck,
  },
  received: {
    label: "Đã nhận",
    color: "text-green-700",
    bg: "bg-green-100",
    ring: "ring-green-200",
    dot: "bg-green-500",
    icon: Inbox,
  },
  seen: {
    label: "Đã xem",
    color: "text-violet-700",
    bg: "bg-violet-100",
    ring: "ring-violet-200",
    dot: "bg-violet-500",
    icon: Eye,
  },
  failed: {
    label: "Thất bại",
    color: "text-orange-700",
    bg: "bg-orange-100",
    ring: "ring-orange-200",
    dot: "bg-orange-500",
    icon: AlertTriangle,
  },
  dead: {
    label: "Đã dừng",
    color: "text-red-700",
    bg: "bg-red-100",
    ring: "ring-red-200",
    dot: "bg-red-600",
    icon: Skull,
  },
};

export const getStatusInfo = (status) =>
  STATUS_LABELS[status] || {
    label: status || "Không rõ",
    color: "text-gray-700",
    bg: "bg-gray-100",
    ring: "ring-gray-200",
    dot: "bg-gray-400",
    icon: Clock,
  };

/** Filter chip ordering shown in BotMessagesTimeline. */
export const STATUS_FILTER_ORDER = [
  "pending",
  "scheduled",
  "sending",
  "sent",
  "received",
  "seen",
  "failed",
  "dead",
];
